import { CustomFieldType } from '@w3lcome/types';
import { CustomFieldWithError } from '_/interfaces/CustomFieldWithError';

export function isFieldVisible(
  field: CustomFieldWithError,
  allFields: CustomFieldWithError[],
  getVisitDataByField: (field: CustomFieldWithError) => string | boolean
): boolean {
  if (!field.triggerFieldId) return true;

  const triggerField = allFields.find((f) => f.id === field.triggerFieldId);
  if (!triggerField) return true;

  const currentValue = getVisitDataByField(triggerField);

  if (triggerField.type === CustomFieldType.BOOLEAN) {
    return currentValue === true || currentValue === 'true';
  }

  if (
    triggerField.type === CustomFieldType.DROPDOWN ||
    triggerField.type === CustomFieldType.VISIT_REASON
  ) {
    const triggerOption = triggerField.options?.find((opt) => opt.id === field.triggerOptionId);
    if (!triggerOption) return false;
    return currentValue === triggerOption.name;
  }

  return true;
}
